<div class="app">
  @if (notProd) {
    <kin-non-prod-banner></kin-non-prod-banner>
  }
  <app-header></app-header>

  <div class="content" [attr.data-loading]="isLoading">
    <main class="app-main">
      <router-outlet></router-outlet>
    </main>

    <app-footer />

    @if (isReviewPage()) {
      <section class="sticky bottom-0 flex bg-neutral-white print:hidden" data-testid="footer-component">
        <app-footer-review></app-footer-review>
      </section>
    }

    <!-- Application Level Loading Overlay Screen -->
    <app-global-loading-container></app-global-loading-container>

    <!-- Application Level Contact Us Dialog -->
    <app-global-contact-dialog></app-global-contact-dialog>
  </div>
</div>
